import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  align: "center",
  style: {"margin":"0 !important","padding":"0 !important"},
  class: "logo-n-menu"
}
const _hoisted_4 = {
  class: "logo",
  width: "50%"
}
const _hoisted_5 = {
  class: "nav",
  width: "50%"
}
const _hoisted_6 = {
  class: "left aos-init aos-animate",
  "data-aos": "fade-right",
  "data-aos-duration": "2000"
}
const _hoisted_7 = { style: {"color":"#999"} }

import HomeBurgerMenu from "@/views/partials/HomeBurgerMenu.vue";
import RentersLogo from "@/views/partials/RentersLogo.vue";
import { defineAsyncComponent } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeHero',
  emits: ["showModal"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
function showModal(args: any[]) {
  emit("showModal", args);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_4, [
              _createVNode(RentersLogo)
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(HomeBurgerMenu)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hidemobile" }, [
          _createElementVNode("br"),
          _createElementVNode("br")
        ], -1)),
        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "hero-title" }, [
          _createTextVNode(" Affordable "),
          _createElementVNode("span", null, "Renters Insurance"),
          _createElementVNode("div", { class: "subhero-title" }, "for College Students")
        ], -1)),
        _createVNode(_component_router_link, { to: { name: 'quote' } }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("button", null, "Start a Quote", -1)
          ]))]),
          _: 1
        }),
        _cache[8] || (_cache[8] = _createElementVNode("p", null, [
          _createTextVNode(" Apartment, House, Condo, Townhouse, or Dorm Room. "),
          _createElementVNode("span", { style: {"display":"block"} }, " The unexpected can happen. NSSI has your back when it does. ")
        ], -1)),
        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
        _cache[10] || (_cache[10] = _createElementVNode("p", null, [
          _createElementVNode("strong", null, "Coverage for peace of mind. ")
        ], -1)),
        _createElementVNode("p", null, [
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("small", _hoisted_7, [
            _createVNode(_component_router_link, { to: { name: 'legalAssurant' } }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Assurant underwriter ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})